import { useMutation, useQueryClient } from 'react-query'
import vehicleProfilesApi from './actions'
import { vehicleProfilesKeys } from './constants'

const useVehicleProfilesMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createVehicleProfile = useMutation(
    vehicleProfilesApi.createVehicleProfile,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(vehicleProfilesKeys.root(companyId))
      },
    },
  )

  const updateVehicleProfile = useMutation(
    vehicleProfilesApi.updateVehicleProfile,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(vehicleProfilesKeys.root(companyId))
      },
    },
  )

  const deleteVehicleProfile = useMutation(
    vehicleProfilesApi.deleteVehicleProfile,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(vehicleProfilesKeys.root(companyId))
      },
    },
  )

  return { createVehicleProfile, updateVehicleProfile, deleteVehicleProfile }
}

export default useVehicleProfilesMutations
